import React from 'react';
import { connect } from 'react-redux';
import Hierarchy from 'components/Hierarchy';
import { getDefsWithParents, sortByYoungest } from './hierarchyUtils';

function HierarchyContainer({ relatedEntities, defs: d, entity }) {
  let relatedEntityTypes = Object.keys(relatedEntities).filter(key =>
    key !== 'case' &&
    key !== 'annotation' &&
    relatedEntities[key].length
  );

  let defs = d.filter(def =>
    [ ...relatedEntityTypes, entity.type ].some(x => x === def.id)
  );

  let defsWithParents = getDefsWithParents({ defs });
  let hierarchy = sortByYoungest({ defsWithParents });

  let props = { entity, hierarchy,
    relatedEntities:
      relatedEntityTypes.map(key => ({ [key]: relatedEntities[key] }))
  };

  return <Hierarchy { ...props } />;
}


export default connect(
  state => ({
    relatedEntities: state.details.relatedEntities,
    defs: state.entityDefinitions.defs
  })
)(HierarchyContainer);
